import { appPairedIcon } from '@/shared/ui/assets';
import { Chip, CustomTooltip, IconButton } from '@/shared/ui/components';
import React from 'react';
import { t } from 'ttag';
import type { AppPairedProps } from './appPaired.types';
import './appPaired.scss';

const AppPaired: React.FC<AppPairedProps> = (props) =>
  props.hasTooltip ? (
    <CustomTooltip title={t`App paired`} placement="bottom">
      <div className="tooltip-button-wrapper">
        <IconButton
          id="app-paired-icon"
          className="app-paired-icon"
          aria-label="App paired"
          iconComponent={<img src={appPairedIcon} alt="App paired Icon" />}
        />
      </div>
    </CustomTooltip>
  ) : (
    <Chip
      style={{ border: 1, paddingInline: 8 }}
      background="#EBF8FF"
      color="#005FB2"
      closable={false}
    >
      <>
        <img src={appPairedIcon} alt="App paired Icon" style={{ width: 16, marginRight: 4 }} />
        {t`App paired`}
      </>
    </Chip>
  );

export default AppPaired;
